module.exports = __webpack_public_path__ + "static/media/project-thumbnail08.9e4d47c3.jpg";